<script setup>
import { inject, onMounted } from 'vue';
import LoginContainer from '@/components/Auth/LoginContainer';
import axios from 'axios';
import { router } from '@inertiajs/vue3';
import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';

const { locale } = storeToRefs(useUserStore());

const props = defineProps({
    errors: {
        type: Object,
        default: _ => ({})
    }
});

const user = {
    email: '',
    password: '',
    password_confirmation: '',
};

const getError = selector => (props.errors[selector] || null);

onMounted(() => {
    const urlParams = new URLSearchParams(window.location.search);
    user.code = urlParams.get('code');
});

const isLoading = inject('isLoading');
const login = async () => {
    if (!isLoading.value) {
        await axios.get('/sanctum/csrf-cookie');
        const payload = {
            ...user,
            locale: locale.value
        };
        axios.post('/register', payload)
            .then(({ data }) => {
                router.visit(data?.redirect || '/kaleadicals');
            }).catch(() => {
                console.error('Login failed');
            });
    }
};

</script>
<template>
<LoginContainer>
    <template #title>Register</template>
    <form @submit.prevent="login">
        <StyledInput
            v-model="user.email"
            type="email"
            name="email"
            :error-message="getError('email')"
            :placeholder="$t('label.email')"
            :label="$t('label.email')" />
        <StyledPassword
            v-model="user.password"
            class="password"
            :error-message="getError('password')"
            name="password"
            placeholder="******************"
            :label="$t('label.password')" />
        <StyledPassword
            v-model="user.password_confirmation"
            class="password_confirmation"
            :error-message="getError('password_confirmation')"
            name="password_confirmation"
            placeholder="******************"
            label="Password Confirmation" />
        <StyledButton
            type="submit"
            color="primary"
            class="mb-4">
            Register
        </StyledButton>
    </form>
</LoginContainer>
</template>

